import React from 'react';
import { useIntl } from 'react-intl';

import { TextArea } from '~/eds/src/components/TextArea/TextArea';
import { Field } from '~/evifields/src/types/Field';
import { Filter } from '~/evifields/src/types/Filter';
import { EnumValue, TextValue } from '~/evifields/src/types/Value';
import { DOCUMENT_ID_FILTER } from '~/features/filters/constants';
import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';
import { Nullable } from '~/types/Nullable';

import { TextDelimitedEnumSetValue as TextDelimitedEnumSetValue_DEPRECATED } from '../../Filters_DEPRECATED/subcomponents/TextDelimitedEnumSetValue_DEPRECATED';
import { TextDelimitedEnumSetValue } from './TextDelimitedEnumSetValue';

interface Props {
  filter: Filter<TextValue>;
  field: Field;
  onChange: (_updatedValues: TextValue[]) => void;
}

export const TextValues = ({ field, filter, onChange }: Props): JSX.Element => {
  const intl = useIntl();
  const { id, values } = filter;
  const [value = ''] = values;
  const isFilterChipApplyButton = useFlag(FlagType.FilterChipApplyButton);
  const TextDelimitedEnumSetValueComponent = isFilterChipApplyButton
    ? TextDelimitedEnumSetValue
    : TextDelimitedEnumSetValue_DEPRECATED;

  // Special filter case. It has text type but the operators are EnumSetValue.
  const isDocumentIdFilter = field.label === DOCUMENT_ID_FILTER;

  const handleChange = (updatedValue: Nullable<string>) => {
    onChange(updatedValue ? [updatedValue] : []);
  };

  const handleTextDelimitedChange = (updatedValue: EnumValue[]) => {
    onChange(updatedValue.length ? [updatedValue.join(',')] : []);
  };

  if (isDocumentIdFilter) {
    return (
      <TextDelimitedEnumSetValueComponent
        fieldId={field.id}
        onChange={handleTextDelimitedChange}
        values={value ? value.split(',') : []}
      />
    );
  }

  return (
    <TextArea
      name={id}
      value={value}
      placeholder={intl.formatMessage({
        id: 'Filters.TextValues.placeholderContent',
        defaultMessage: 'Content',
        description: 'Placeholder for text value input on filter dropdown',
      })}
      onChange={handleChange}
    />
  );
};
